import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=3d4d8ef3&scoped=true&"
import script from "./SideBySide.vue?vue&type=script&lang=ts&"
export * from "./SideBySide.vue?vue&type=script&lang=ts&"
import style0 from "./SideBySide.vue?vue&type=style&index=0&id=3d4d8ef3&scoped=true&lang=css&"
import style1 from "./SideBySide.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d8ef3",
  null
  
)

export default component.exports